<template>
  <div class="main-conent main-conent-maxheight main-fixed">
    <div class="main-fixed__head">
      <slot name="header"></slot>
    </div>

    <div class="main-fixed__body">
      <slot></slot>
    </div>

    <div v-if="$slots.footer" class="main-fixed__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.main-fixed {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .main-fixed__head {
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
  }
  &.search .main-fixed__head {
    padding-bottom: 0;
  }
  .main-fixed__body {
    flex: 1;
    overflow: hidden;
  }
  .main-fixed__footer {
    padding-bottom: 20px;
    border-top: 1px solid #ebeef5;
  }
}
</style>
